const ROUTES = {
  pricing: "/pricing",
}

export default ROUTES
